import React from "react";
import HcsEdit from "./hcs-edit";

export default class HcsNumberInput extends HcsEdit {
    constructor(props) {
        super(props);

        this.valueUpDown = this.valueUpDown.bind(this);
    }

    valueUpDown(direction) {
        let inputField = this.inputRef.current;

        let currentValue = parseInt(this.cleanValue(inputField.value.trim()));

        if(isNaN(currentValue)) {
            currentValue = this.limits.min;
        }

        let newValue = currentValue;

        switch(direction) {
            case "down":
                newValue = Math.max(this.limits.min, currentValue - this.limits.step);
                break;

            case "up":
                newValue = Math.min(this.limits.max, currentValue + this.limits.step);
                break;
        }

        if(currentValue != newValue) {
            this.valueChanged(newValue.toString());
        }
    }

    /**
     * Return allowed value limits min/max
     * and increments step value when user clicks the +/- buttons.
     */
    get limits() {
        const { data } = this.props;

        return {
            min: data.info.minincl ? data.info.min : 0,
            max: data.info.maxincl ? data.info.max : 99999999,
            step: data.info.step || 1
        };
    }

    get inputFieldValue() {
        const { data } = this.props;

        return data.info.value || (data.info.min || "").toString();
    }

    childClass() {
        return "hcs-number-input";
    }

    renderControl() {
        const { data } = this.props;

        // By creating a unique "key" attribute for the outer container
        // we ensure to always render with the current value (as defaultValue) from ECS.
        // The uniqueness is being guaranteed by using either the ident and value.
        // See https://stackoverflow.com/questions/30727837/react-change-input-defaultvalue-by-passing-props/41962233 for details
        return (
            <React.Fragment key={data.ident + "_" + data.info.value}>
                <div className="hcs-control">
                    {
                        this.props.children
                    }
                    <div className="hcs-input-controls">
                        <span className="hcs-number-button hcs-down" onClick={_ => this.valueUpDown("down")}>
                            <svg icon-id="icn-006-2-less" version="2.0">
                                <use href="#icn-006-2-less"></use>
                            </svg>
                        </span>
                        {
                            this.renderInputField()
                        }
                        <span className="hcs-number-button hcs-up" onClick={_ => this.valueUpDown("up")}>
                            <svg icon-id="icn-005-2-more" version="2.0">
                                <use href="#icn-005-2-more"></use>
                            </svg>
                        </span>
                    </div>
                </div>
                {
                    this.state.error !== null ? <span className="hcs-error">{this.state.error}</span> : null
                }
            </React.Fragment>);
    }
}